<template>
  <nx-bform-group :label="requiredLabel(name)" v-bind="$attrs">
    <nx-bform-radio-group
      :name="name"
      :rules="{ required }"
      :options="[
        { text: $t('yes'), value: true },
        { text: $t('no'), value: false }
      ]"
      :value="$attrs.value"
      @input="$listeners.input"
    />
  </nx-bform-group>
</template>

<script>
import FormGroupMixin from "../form-group.mixin";

export default {
  mixins: [FormGroupMixin],
  computed: {
    name() {
      return this.label || this.$t("haveEshAccount");
    }
  }
};
</script>

<i18n src="@/locales/registration.locale"></i18n>

<i18n src="@/locales/msg.locale"></i18n>
